import React, { Component, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./components/Header";
import Estudiantes from "./components/Estudiantes";
import Estudiante from "./components/Estudiante";
import Login from "./components/Login";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Especialidades from "./components/admin/Especialidades";
import Agencias from "./components/admin/Agencias";

import "../src/styles/main.css";
import Usuarios from "./components/admin/Usuarios";
import Bienvenido from "./components/Bienvenido";
import { getPermissions } from "./utils/utils";

//https://medium.com/@thanhbinh.tran93/private-route-public-route-and-restricted-route-with-react-router-d50b27c15f5e

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <PublicRoute
              restricted={true}
              component={Login}
              path="/login"
              exact
            />
            <Route exact path="/login">
              <Login />
            </Route>

            <Route exact path="/">
              <Login />
            </Route>
            <PrivateRoute component={Estudiante} path="/estudiante" exact />
            <PrivateRoute
              component={Especialidades}
              path="/especialidades"
              exact
            />
            <PrivateRoute component={Agencias} path="/agencias" exact />
            <PrivateRoute
              component={Estudiante}
              disabled="disabled"
              path="/estudiante/:id"
              exact
            />
            <PrivateRoute
              component={Estudiante}
              path="/estudiante/edit/:id"
              exact
            />
            <PrivateRoute component={Estudiantes} path="/estudiantes" exact />
            <PrivateRoute component={Usuarios} path="/usuarios" exact />
            <PrivateRoute component={Bienvenido} path="/bienvenido" exact />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
